<mat-toolbar class="toolbar">
  @if (isMobile()) {
    <div class="mobile-toolbar">
      <p class="mobile-toolbar__summary">{{ getSearchSummary() }}</p>
      <div class="mobile-toolbar__actions">
        <div class="chargepoints-count">
          <div class="chargepoint-count">
            <mat-icon [inline]="true">info</mat-icon>
            <span class="chargepoint-count-value">{{ (displayedChargepoints$ | async)?.length || 0 }}</span>
          </div>
        </div>
        <button
          mat-icon-button
          type="button"
          aria-label="Toggle sort direction"
          (click)="searchFormGroup.controls.reverse.setValue(!searchFormGroup.controls.reverse.value)"
        >
          <mat-icon>{{ searchFormGroup.controls.reverse.value ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
        </button>
        <button mat-icon-button type="button" aria-label="Open search filters" (click)="openSearchDialog()">
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>
    </div>
  } @else {
    <form class="search-form" [formGroup]="searchFormGroup">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Chargepoint type</mat-label>
        <mat-select formControlName="type">
          <mat-option value="all">All</mat-option>
          <mat-option value="OCPP">OCPP</mat-option>
          <mat-option value="OKECHARGE">OkeCharge</mat-option>
          <mat-option value="IVY">Ivy</mat-option>
          <mat-option value="NETATMO">Netatmo</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Search by ID</mat-label>
        <input matInput type="text" placeholder="some/id ..." formControlName="id">
        @if (searchFormGroup.get('id')?.value) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="searchFormGroup.controls.id.setValue('')">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
      <div class="spacer"></div>
      <div class="chargepoints-count">
        <div class="chargepoint-count">
          <mat-icon [inline]="true">info</mat-icon>
          <span class="chargepoint-count-value">{{ (displayedChargepoints$ | async)?.length || 0 }}</span>
        </div>
      </div>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Advanced filter</mat-label>
        <mat-select formControlName="advancedFilter">
          <mat-option *ngFor="let filter of advancedFilterOptions" [value]="filter.id">
            {{ filter.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Order by</mat-label>
        <mat-select formControlName="orderBy">
          <mat-option value="id">Identifier</mat-option>
          <mat-option value="type">Type</mat-option>
          <mat-option value="status">Status </mat-option>
          <mat-option value="lastHeartbeat">Last heartbeat</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button (click)="searchFormGroup.controls.reverse.setValue(!searchFormGroup.controls.reverse.value)">
        <mat-icon>{{ searchFormGroup.controls.reverse.value ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
      </button>
    </form>
  }
</mat-toolbar>

<!-- Affichage du filtre sélectionné -->
@if (!isMobile() && getSelectedFilterText()) {
  <div class="filter-info">
    <mat-icon [inline]="true">filter_list</mat-icon>
    <span class="filter-text">{{ getSelectedFilterText() }}</span>
    <button mat-icon-button
            class="copy-button"
            (click)="copyFilterToClipboard()"
            matTooltip="Copy filter to clipboard"
            aria-label="Copy filter">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
}

<mat-progress-bar *ngIf="searching" mode="indeterminate"></mat-progress-bar>
<ng-container *ngIf="displayedChargepoints$ | async as chargepoints">
  <div class="chargepoints-list" *ngIf="chargepoints.length > 0; else empty">
    <app-chargepoint-card [chargepoint]="chargepoint" *ngFor="let chargepoint of chargepoints" (goToChargepointClick)="goToChargepoint(chargepoint.id)"></app-chargepoint-card>
  </div>
</ng-container>
<ng-template #empty>
  <div class="disclaimer">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    <p>No chargepoints found</p>
  </div>
</ng-template>
